import React from "react";
import style from "./ScrollButton.module.scss";
import {ReactComponent as ButtonDefault} from "../../../images/slider/buttonDefault.module.svg"
import clsx from "clsx";


interface ScrollButtonProps {
    direction: 'left' | 'right';
    onScroll: () => void; // Обработчик события скролла
    disabled?: boolean; // Статус кнопки
}

const ScrollButton: React.FC<ScrollButtonProps> = ({direction, onScroll, disabled}) => {

    return (
        <button
            className={clsx(style.scrollButton, {[style.disabled]: disabled})}
            onClick={onScroll}
            disabled={disabled}
        >
            <ButtonDefault style={{transform: direction === 'left' ? 'rotate(180deg)' : 'none'}}/>

        </button>
    );
};

export default ScrollButton;